export default __webpack_public_path__ + "static/media/image.f46bcdc3.png";